module.exports = __webpack_public_path__ + "static/media/impact_88_logo.8e459d0c.png";